import { useSetAtom } from 'jotai';
import { parse } from 'qs';
import { isNil, omitBy } from 'lodash-es';
import { globalFilterParamsAtom } from '@/app/_shared/store/search-filter';
import { updateQueryAndScroll } from '../utils/update-query-and-scroll';

export const useResetFilterWithQuery = () => {
  // store setter
  const setGlobalFilterParam = useSetAtom(globalFilterParamsAtom);

  const resetFilterWithQuery = () => {
    // 현재 쿼리 문자열 파싱
    const currentQuery = parse(new URLSearchParams(window.location.search).toString());

    // 새로운 쿼리 문자열 생성
    const newQuery = omitBy(
      {
        ...currentQuery,
        filter: undefined,
        switchFilter: undefined,
        rangeFilter: undefined,
      },
      (value) => isNil(value) || value === '',
    );

    // 글로벌 필터 파라미터 clear
    setGlobalFilterParam(undefined);

    // URL 업데이트
    updateQueryAndScroll(newQuery);
  };

  return { resetFilterWithQuery };
};
